<template>
  <div class="file">
    <img
      v-if="iconType"
      class="file__icon"
      :src="`/img/svg/files/icon-file-type--${iconType}.svg`"
    >

    <svgicon
      v-else
      class="file__icon file__icon--default svg-icon--file"
      icon="file"
      width="25"
      height="25"
    />

    <VTooltip
      :popupText="fileName"
      :showTip="hasTooltip"
    >
      <a
        href="#"
        target="_blank"
        class="file__name"
        @click="showFile"
        @mousedown="handleMouseDown($event)"
        @contextmenu.prevent="showContextMenu($event)"
      >
        <span v-if="showDate">
          {{ fileCreatedDate }}
        </span>
        {{ fileName | stringMaxLength(maxLengthName) }}
      </a>
    </VTooltip>

    <span v-if="showSize" class="file__size">{{ fileSizeMb }}&nbsp;Мб</span>

    <div v-if="hasButtonDownload || hasButtonRemove" class="d-flex ai-fs gap-xxs">
      <VButton
        v-if="hasButtonDownload"
        icon="download"
        size="sm"
        class="btn--no-shadow-always"
        @click.native="downloadFile" />

      <VButton
        v-if="hasButtonRemove"
        icon="remove"
        size="sm"
        class="btn--no-shadow-always"
        @click.native="onRemove" />
    </div>
    <ContextMenu
      v-if="contextMenu.visible"
      :x="contextMenu.x"
      :y="contextMenu.y"
      @close="hideContextMenu"
    >
      <VButton
        text="Открыть ссылку в новой вкладке"
        size="sm"
        @click.native="openLink"
      />
      <VButton
        text="Открыть превью файла"
        size="sm"
        @click.native="showFile"
      />
    </ContextMenu>
  </div>
</template>

<script>
import VTooltip from '@/components/ui/VTooltip'
import { mixinFile } from '@/mixins/files/mixinFile'
import { getFileTypeBy, getFileCreatedDate } from '@/utils/files'
import VButton from '@/components/simple/button/VButton.vue'
import mediaService from '@/services/media.service'
import ContextMenu from '@/components/ui/ContextMenu.vue'

export default {
  name: 'AttachmentFile',
  components: { ContextMenu, VButton, VTooltip },
  mixins: [mixinFile],
  props: {
    maxLengthName: {
      type: Number,
      required: false,
      default: 30
    },
    hasButtonRemove: {
      type: Boolean,
      required: false,
      default: false
    },
    withPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    hasButtonDownload: {
      type: Boolean,
      default: false
    },
    showDate: {
      type: Boolean,
      default: false
    },
    showSize: {
      type: Boolean,
      default: true
    },
    fileAutoLoad: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contextMenu: {
        visible: false,
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    hasTooltip () {
      return this.fileName.length > this.maxLengthName
    },
    fileSizeMb () {
      return (this.file.size / 1024 / 1024).toFixed(1)
    },
    iconType () {
      switch (this.fileType) {
        case 'docx':
        case 'doc': return 'doc'
        case 'xlsx':
        case 'xls': return 'xls'
        case 'pdf': return 'pdf'
        case 'png': return 'png'
        case 'webp': return 'webp'
        case 'gif': return 'gif'
        case 'jpg':
        case 'jpeg': return 'jpeg'
        default: return ''
      }
    },
    fileType () {
      return getFileTypeBy(this.fileName)
    },
    fileCreatedDate () {
      return getFileCreatedDate(this.file)
    }
  },
  methods: {
    async handleMouseDown (event) {
      // Средняя кнопка мыши
      if (event.button !== 1) {
        return
      }

      event.preventDefault()

      // Открываем новое окно. Загружаем файл и подставляем ссылку в окно
      await this.openInNewWindow()
    },
    async showFile (event) {
      if (this.withPreview) {
        event.preventDefault()
        this.$emit('show-file')
      } else {
        await mediaService.open(this.file)
      }
      this.hideContextMenu()
    },
    onRemove () {
      this.$emit('remove-file')
    },
    async downloadFile () {
      await mediaService.download(this.file)
    },

    showContextMenu (event) {
      this.contextMenu.x = event.clientX
      this.contextMenu.y = event.clientY
      this.contextMenu.visible = true
    },

    hideContextMenu () {
      this.contextMenu.visible = false
    },

    async openLink () {
      await this.openInNewWindow()
      this.hideContextMenu()
    },

    async openInNewWindow () {
      const newWindow = window.open('', '_blank')

      if (!newWindow) {
        return
      }

      try {
        newWindow.location.href = await mediaService.getObjectUrl(this.file)
      } catch (e) {
        newWindow.close()
      }
    }
  },
  beforeDestroy () {
    mediaService.revoke(this.file)
  }
}
</script>
